import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    textField: {
      width: '100%',
    },
    inputRoot: {
      fontSize: theme.typography.pxToRem(14),
    },
    error: {
      fontSize: theme.typography.pxToRem(13),
      lineHeight: theme.typography.pxToRem(20),
      marginTop: theme.spacing(0.5),

      '&&': {
        color: theme.palette.error.main,
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    option: {
      fontFamily: 'monospace',
    },
  }),
  { name: 'AnnotationInput' }
);
